// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DocumentStep-module__formBox--K18CO {
    flex-grow: 1;
    padding: 20px;
    border-radius: 16px;
    width: 80%;
    margin: 0px auto;
    display: flex;
    flex-direction: column;
}

.DocumentStep-module__btnBoxNext--OO7NY {
    display: flex;
    justify-content: end;
}

.DocumentStep-module__titleBox--_vVdl>h4 {
    margin: 0 0 20px 0;
    font-size: 18px;
    font-weight: 500;
    color: var(--color-title);

}

.DocumentStep-module__fieldBox--FlX1H {
    display: flex;
    gap: 20px;
    flex-direction: column;
}

.DocumentStep-module__FileItemBorder--VxESZ {
    display: flex;
    align-items: center;
    gap: 20px;
    cursor: pointer;
    height: 20px;
    margin: 10px 0;
}

.DocumentStep-module__FileItemBorder--VxESZ>a {
    size: 15px;
    color: #6F879C;
}

.DocumentStep-module__premium--c_qHN {
    display: flex;
    justify-content: center;
}

.DocumentStep-module__premium--c_qHN>span {
    color: var(--color-primary);
    font-size: 25px;
    font-weight: bold;
}

.DocumentStep-module__infoText--TfYn4>p {
    width: 100%;
    font-size: 14px;
    margin-top: 0;
}

.DocumentStep-module__infoText--TfYn4>span,
.DocumentStep-module__infoText--TfYn4>p>span {
    font-size: 14px;
    font-weight: bold;
    color: var(--color-primary);
    overflow-wrap: break-word;
    word-wrap: break-word;
}

.DocumentStep-module__colorBox--HRK14>p>span {
    font-weight: bold;
    color: var(--color-primary);
}

.DocumentStep-module__colorBox--HRK14,
.DocumentStep-module__redBox--INnak {
    margin: 20px 0;
    display: flex;
    gap: 10px;
    align-content: center;
    justify-content: center;
    align-items: center;
    background-color: #e2e9ff;
    border-radius: 20px;
    padding: 5px;
}

.DocumentStep-module__redBox--INnak {
    background-color: #ffe2e2;
}

.DocumentStep-module__colorBox--HRK14>p,
.DocumentStep-module__redBox--INnak>p {
    margin: 0;
}

.DocumentStep-module__icon--eRDI_>svg {
    color: var(--color-primary);
    font-size: 25px;
}

.DocumentStep-module__linkAppBox--k5bjJ {
    display: flex;
    gap: 10px;
    justify-content: center;
    margin-top: 20px;
    max-width: 300px;
    flex-wrap: wrap;
}

.DocumentStep-module__otherPrograms--kVWn0 {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.DocumentStep-module__programIten--hYdsn {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px;
}

.DocumentStep-module__previousPrice--V3dGl {
    text-decoration: line-through;
    color: var(--color-title);
}

.DocumentStep-module__colorPremium--mvsxY {
    color: var(--color-primary);
    font-weight: bold;
}

.DocumentStep-module__suggestion--gE2cy {
    margin-bottom: 0;
    color: var(--color-title);
}

.DocumentStep-module__modalBox--a7SRt {
    padding: 15px;
}

.DocumentStep-module__modalBox--a7SRt>h3 {
    margin: 0;
    color: var(--color-title);
}

.DocumentStep-module__premiumModalLine--XpUWE>p,
.DocumentStep-module__premiumModalLine--XpUWE>div>p,
.DocumentStep-module__territoryModal--wXXBq>span {
    font-size: 15px;
    font-weight: 300;
    display: flex;
    margin: 4px;
    color: var(--color-title);
}


.DocumentStep-module__premiumModalLine--XpUWE>span {
    font-size: 15px;
    font-weight: 600;
    display: flex;
    margin: 4px;
    color: var(--color-title);
    align-items: center;
}



.DocumentStep-module__premiumModalLine--XpUWE>span>svg,
.DocumentStep-module__premiumModalBox--L1GMH>span>svg {
    height: 14px;
}

.DocumentStep-module__colorPremium--mvsxY {
    color: var(--color-primary);
    display: flex;
    align-items: center;
    justify-content: center;
}

.DocumentStep-module__premiumModal--hjZ6_ {
    background-color: rgb(43 93 235 / 5%);
    padding: 10px;
    border-radius: 14px;
}

.DocumentStep-module__premiumModalLine--XpUWE {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 20px;
}



.DocumentStep-module__territoryTitleModal--fxeio {
    font-size: 16px;
    font-weight: 500;
    text-transform: uppercase;
    color: var(--color-primary);
}



.DocumentStep-module__previousPriceModal--nGjUk {
    text-decoration: line-through;
    color: var(--color-title);
    margin: 0;
}

.DocumentStep-module__premiumModalBox--L1GMH {
    display: flex;
    gap: 20px;
    align-items: center;
    justify-content: center;
}

.DocumentStep-module__descriptionModal--ocvpL {
    font-size: 15px;
    font-weight: 300;
    display: flex;
    margin: 4px;
    color: var(--color-title);
}

.DocumentStep-module__checkboxContainer--xMyhu {
    display: flex;
    flex-direction: column;
}

@media (max-width: 950px) {
    .DocumentStep-module__formBox--K18CO {
        width: 80%;
    }

    .DocumentStep-module__premiumModalLine--XpUWE {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        border-bottom: 1px solid #6f879c38;
        gap: 0px;
    }

    .DocumentStep-module__premiumModalLine--XpUWE:last-child {
        border-bottom: none;
    }
}`, "",{"version":3,"sources":["webpack://./src/features/cancer-protection/step-3/ui/DocumentStep.module.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;;AAE7B;;AAEA;IACI,aAAa;IACb,SAAS;IACT,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,2BAA2B;IAC3B,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,aAAa;AACjB;;AAEA;;IAEI,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA;;IAEI,cAAc;IACd,aAAa;IACb,SAAS;IACT,qBAAqB;IACrB,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,SAAS;AACb;;AAEA;IACI,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,aAAa;AACjB;;AAEA;IACI,6BAA6B;IAC7B,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;IAC3B,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,SAAS;IACT,yBAAyB;AAC7B;;AAEA;;;IAGI,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,WAAW;IACX,yBAAyB;AAC7B;;;AAGA;IACI,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,WAAW;IACX,yBAAyB;IACzB,mBAAmB;AACvB;;;;AAIA;;IAEI,YAAY;AAChB;;AAEA;IACI,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,qCAAqC;IACrC,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;AACb;;;;AAIA;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,2BAA2B;AAC/B;;;;AAIA;IACI,6BAA6B;IAC7B,yBAAyB;IACzB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB,kCAAkC;QAClC,QAAQ;IACZ;;IAEA;QACI,mBAAmB;IACvB;AACJ","sourcesContent":[".formBox {\r\n    flex-grow: 1;\r\n    padding: 20px;\r\n    border-radius: 16px;\r\n    width: 80%;\r\n    margin: 0px auto;\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.btnBoxNext {\r\n    display: flex;\r\n    justify-content: end;\r\n}\r\n\r\n.titleBox>h4 {\r\n    margin: 0 0 20px 0;\r\n    font-size: 18px;\r\n    font-weight: 500;\r\n    color: var(--color-title);\r\n\r\n}\r\n\r\n.fieldBox {\r\n    display: flex;\r\n    gap: 20px;\r\n    flex-direction: column;\r\n}\r\n\r\n.FileItemBorder {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 20px;\r\n    cursor: pointer;\r\n    height: 20px;\r\n    margin: 10px 0;\r\n}\r\n\r\n.FileItemBorder>a {\r\n    size: 15px;\r\n    color: #6F879C;\r\n}\r\n\r\n.premium {\r\n    display: flex;\r\n    justify-content: center;\r\n}\r\n\r\n.premium>span {\r\n    color: var(--color-primary);\r\n    font-size: 25px;\r\n    font-weight: bold;\r\n}\r\n\r\n.infoText>p {\r\n    width: 100%;\r\n    font-size: 14px;\r\n    margin-top: 0;\r\n}\r\n\r\n.infoText>span,\r\n.infoText>p>span {\r\n    font-size: 14px;\r\n    font-weight: bold;\r\n    color: var(--color-primary);\r\n    overflow-wrap: break-word;\r\n    word-wrap: break-word;\r\n}\r\n\r\n.colorBox>p>span {\r\n    font-weight: bold;\r\n    color: var(--color-primary);\r\n}\r\n\r\n.colorBox,\r\n.redBox {\r\n    margin: 20px 0;\r\n    display: flex;\r\n    gap: 10px;\r\n    align-content: center;\r\n    justify-content: center;\r\n    align-items: center;\r\n    background-color: #e2e9ff;\r\n    border-radius: 20px;\r\n    padding: 5px;\r\n}\r\n\r\n.redBox {\r\n    background-color: #ffe2e2;\r\n}\r\n\r\n.colorBox>p,\r\n.redBox>p {\r\n    margin: 0;\r\n}\r\n\r\n.icon>svg {\r\n    color: var(--color-primary);\r\n    font-size: 25px;\r\n}\r\n\r\n.linkAppBox {\r\n    display: flex;\r\n    gap: 10px;\r\n    justify-content: center;\r\n    margin-top: 20px;\r\n    max-width: 300px;\r\n    flex-wrap: wrap;\r\n}\r\n\r\n.otherPrograms {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 10px;\r\n}\r\n\r\n.programIten {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    padding: 20px;\r\n}\r\n\r\n.previousPrice {\r\n    text-decoration: line-through;\r\n    color: var(--color-title);\r\n}\r\n\r\n.colorPremium {\r\n    color: var(--color-primary);\r\n    font-weight: bold;\r\n}\r\n\r\n.suggestion {\r\n    margin-bottom: 0;\r\n    color: var(--color-title);\r\n}\r\n\r\n.modalBox {\r\n    padding: 15px;\r\n}\r\n\r\n.modalBox>h3 {\r\n    margin: 0;\r\n    color: var(--color-title);\r\n}\r\n\r\n.premiumModalLine>p,\r\n.premiumModalLine>div>p,\r\n.territoryModal>span {\r\n    font-size: 15px;\r\n    font-weight: 300;\r\n    display: flex;\r\n    margin: 4px;\r\n    color: var(--color-title);\r\n}\r\n\r\n\r\n.premiumModalLine>span {\r\n    font-size: 15px;\r\n    font-weight: 600;\r\n    display: flex;\r\n    margin: 4px;\r\n    color: var(--color-title);\r\n    align-items: center;\r\n}\r\n\r\n\r\n\r\n.premiumModalLine>span>svg,\r\n.premiumModalBox>span>svg {\r\n    height: 14px;\r\n}\r\n\r\n.colorPremium {\r\n    color: var(--color-primary);\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.premiumModal {\r\n    background-color: rgb(43 93 235 / 5%);\r\n    padding: 10px;\r\n    border-radius: 14px;\r\n}\r\n\r\n.premiumModalLine {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    gap: 20px;\r\n}\r\n\r\n\r\n\r\n.territoryTitleModal {\r\n    font-size: 16px;\r\n    font-weight: 500;\r\n    text-transform: uppercase;\r\n    color: var(--color-primary);\r\n}\r\n\r\n\r\n\r\n.previousPriceModal {\r\n    text-decoration: line-through;\r\n    color: var(--color-title);\r\n    margin: 0;\r\n}\r\n\r\n.premiumModalBox {\r\n    display: flex;\r\n    gap: 20px;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.descriptionModal {\r\n    font-size: 15px;\r\n    font-weight: 300;\r\n    display: flex;\r\n    margin: 4px;\r\n    color: var(--color-title);\r\n}\r\n\r\n.checkboxContainer {\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n@media (max-width: 950px) {\r\n    .formBox {\r\n        width: 80%;\r\n    }\r\n\r\n    .premiumModalLine {\r\n        display: flex;\r\n        flex-direction: column;\r\n        align-items: flex-start;\r\n        border-bottom: 1px solid #6f879c38;\r\n        gap: 0px;\r\n    }\r\n\r\n    .premiumModalLine:last-child {\r\n        border-bottom: none;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"formBox": `DocumentStep-module__formBox--K18CO`,
	"btnBoxNext": `DocumentStep-module__btnBoxNext--OO7NY`,
	"titleBox": `DocumentStep-module__titleBox--_vVdl`,
	"fieldBox": `DocumentStep-module__fieldBox--FlX1H`,
	"FileItemBorder": `DocumentStep-module__FileItemBorder--VxESZ`,
	"premium": `DocumentStep-module__premium--c_qHN`,
	"infoText": `DocumentStep-module__infoText--TfYn4`,
	"colorBox": `DocumentStep-module__colorBox--HRK14`,
	"redBox": `DocumentStep-module__redBox--INnak`,
	"icon": `DocumentStep-module__icon--eRDI_`,
	"linkAppBox": `DocumentStep-module__linkAppBox--k5bjJ`,
	"otherPrograms": `DocumentStep-module__otherPrograms--kVWn0`,
	"programIten": `DocumentStep-module__programIten--hYdsn`,
	"previousPrice": `DocumentStep-module__previousPrice--V3dGl`,
	"colorPremium": `DocumentStep-module__colorPremium--mvsxY`,
	"suggestion": `DocumentStep-module__suggestion--gE2cy`,
	"modalBox": `DocumentStep-module__modalBox--a7SRt`,
	"premiumModalLine": `DocumentStep-module__premiumModalLine--XpUWE`,
	"territoryModal": `DocumentStep-module__territoryModal--wXXBq`,
	"premiumModalBox": `DocumentStep-module__premiumModalBox--L1GMH`,
	"premiumModal": `DocumentStep-module__premiumModal--hjZ6_`,
	"territoryTitleModal": `DocumentStep-module__territoryTitleModal--fxeio`,
	"previousPriceModal": `DocumentStep-module__previousPriceModal--nGjUk`,
	"descriptionModal": `DocumentStep-module__descriptionModal--ocvpL`,
	"checkboxContainer": `DocumentStep-module__checkboxContainer--xMyhu`
};
export default ___CSS_LOADER_EXPORT___;
